(function () {
  var analyticsMeta = document.querySelector(
    'meta[name="mu-google-analytics-id"]'
  );
  if (!analyticsMeta) {
    return;
  }

  var measurementId = analyticsMeta.getAttribute('content');
  if (!/^G-[A-Z0-9]+$/.test(measurementId)) {
    return;
  }

  var messages = {
    cs: {
      title: 'Nastavení cookies',
      promptDescription:
        'Nezbytné cookies, například pro zapamatování jazyka, jsou vždy aktivní. Analytické cookies Google Analytics používáme k měření návštěvnosti pouze s vaším souhlasem. Souhlas platí {months} měsíců a můžete ho kdykoli změnit v patičce portálu.',
      settingsDescription: [
        'Pomocí souborů cookie a souvisejících technologií (dále jen „soubory cookie“) zlepšujeme funkčnost našich stránek a zobrazujeme obsah, který nejlépe odpovídá vašim potřebám a očekáváním.',
        'Udělení souhlasu se soubory cookie může vést ke zpracování vašich osobních údajů v zemích mimo Evropský hospodářský prostor a jejich sdílení s našimi partnery a jejich spolupracujícími stranami.',
      ],
      consentHeading: 'Souhlasím s:',
      necessary: 'Nezbytné cookies (vždy aktivní)',
      necessaryDescription:
        'Soubory cookie jsou nezbytné pro optimální a správné fungování portálu',
      analytics: 'Analytické cookies',
      analyticsDescription:
        'Zvolte analytické nástroje, které smějí měřit návštěvnost a používání portálu.',
      analyticsAll: 'Všechny analytické cookies',
      googleAnalytics: 'Google Analytics',
      googleAnalyticsDescription:
        'Měří návštěvnost portálu. Souhlas platí {months} měsíců a můžete ho kdykoli změnit.',
      showDetails: 'Zobrazit podrobnosti',
      hideDetails: 'Skrýt podrobnosti',
      accept: 'Souhlasím',
      reject: 'Nesouhlasím',
      customize: 'Nastavení',
      close: 'Zavřít nastavení cookies',
      remove: 'Odstranit souhlasy',
      confirm: 'Potvrdit výběr',
      policy: 'Informace o cookies a soukromí',
      footer: 'Nastavení cookies',
    },
    en: {
      title: 'Cookie settings',
      promptDescription:
        'Necessary cookies, for example to remember your language, are always active. We use Google Analytics cookies to measure visits only with your consent. Consent lasts {months} months and can be changed at any time in the footer.',
      settingsDescription: [
        'We use cookies and related technologies (collectively, “cookies”) to improve the functionality of our pages and display content that best matches your needs and expectations.',
        'Giving consent to cookies may result in the processing of your personal data in countries outside the European Economic Area and sharing it with our partners and their cooperating parties.',
      ],
      consentHeading: 'I agree to:',
      necessary: 'Necessary cookies (always active)',
      necessaryDescription:
        'Cookies are necessary for the portal to function optimally and correctly.',
      analytics: 'Analytics cookies',
      analyticsDescription:
        'Choose which analytics tools may measure portal visits and usage.',
      analyticsAll: 'All analytics cookies',
      googleAnalytics: 'Google Analytics',
      googleAnalyticsDescription:
        'Measures portal visits. Consent lasts {months} months and can be changed at any time.',
      showDetails: 'Show details',
      hideDetails: 'Hide details',
      accept: 'I agree',
      reject: 'I do not agree',
      customize: 'Settings',
      close: 'Close cookie settings',
      remove: 'Remove consent',
      confirm: 'Confirm selection',
      policy: 'Cookie and privacy information',
      footer: 'Cookie settings',
    },
    de: {
      title: 'Cookie-Einstellungen',
      promptDescription:
        'Notwendige Cookies, zum Beispiel zum Speichern Ihrer Sprache, sind immer aktiv. Google-Analytics-Cookies zur Messung der Besuche verwenden wir nur mit Ihrer Zustimmung. Die Zustimmung gilt {months} Monate und kann jederzeit in der Fußzeile geändert werden.',
      settingsDescription: [
        'Mithilfe von Cookies und ähnlichen Technologien (zusammen „Cookies“) verbessern wir die Funktionalität unserer Seiten und zeigen Inhalte an, die Ihren Bedürfnissen und Erwartungen am besten entsprechen.',
        'Die Zustimmung zu Cookies kann zur Verarbeitung Ihrer personenbezogenen Daten in Ländern außerhalb des Europäischen Wirtschaftsraums und zur Weitergabe an unsere Partner und deren Kooperationspartner führen.',
      ],
      consentHeading: 'Ich stimme Folgendem zu:',
      necessary: 'Notwendige Cookies (immer aktiv)',
      necessaryDescription:
        'Cookies sind für die optimale und korrekte Funktion des Portals erforderlich.',
      analytics: 'Analyse-Cookies',
      analyticsDescription:
        'Wählen Sie, welche Analyse-Tools Besuche und Nutzung des Portals messen dürfen.',
      analyticsAll: 'Alle Analyse-Cookies',
      googleAnalytics: 'Google Analytics',
      googleAnalyticsDescription:
        'Misst Portalbesuche. Die Zustimmung gilt {months} Monate und kann jederzeit geändert werden.',
      showDetails: 'Details anzeigen',
      hideDetails: 'Details ausblenden',
      accept: 'Ich stimme zu',
      reject: 'Ich stimme nicht zu',
      customize: 'Einstellungen',
      close: 'Cookie-Einstellungen schließen',
      remove: 'Einwilligungen entfernen',
      confirm: 'Auswahl bestätigen',
      policy: 'Informationen zu Cookies und Datenschutz',
      footer: 'Cookie-Einstellungen',
    },
    sk: {
      title: 'Nastavenia cookies',
      promptDescription:
        'Nevyhnutné cookies, napríklad na zapamätanie jazyka, sú vždy aktívne. Cookies Google Analytics na meranie návštevnosti používame iba s vaším súhlasom. Súhlas platí {months} mesiacov a môžete ho kedykoľvek zmeniť v pätičke portálu.',
      settingsDescription: [
        'Pomocou súborov cookie a súvisiacich technológií (ďalej len „súbory cookie“) zlepšujeme funkčnosť našich stránok a zobrazujeme obsah, ktorý najlepšie zodpovedá vašim potrebám a očakávaniam.',
        'Udelenie súhlasu so súbormi cookie môže viesť k spracovaniu vašich osobných údajov v krajinách mimo Európskeho hospodárskeho priestoru a k ich zdieľaniu s našimi partnermi a ich spolupracujúcimi stranami.',
      ],
      consentHeading: 'Súhlasím s:',
      necessary: 'Nevyhnutné cookies (vždy aktívne)',
      necessaryDescription:
        'Súbory cookie sú nevyhnutné pre optimálne a správne fungovanie portálu.',
      analytics: 'Analytické cookies',
      analyticsDescription:
        'Vyberte analytické nástroje, ktoré môžu merať návštevnosť a používanie portálu.',
      analyticsAll: 'Všetky analytické cookies',
      googleAnalytics: 'Google Analytics',
      googleAnalyticsDescription:
        'Meria návštevnosť portálu. Súhlas platí {months} mesiacov a môžete ho kedykoľvek zmeniť.',
      showDetails: 'Zobraziť podrobnosti',
      hideDetails: 'Skryť podrobnosti',
      accept: 'Súhlasím',
      reject: 'Nesúhlasím',
      customize: 'Nastavenia',
      close: 'Zavrieť nastavenia cookies',
      remove: 'Odstrániť súhlasy',
      confirm: 'Potvrdiť výber',
      policy: 'Informácie o cookies a súkromí',
      footer: 'Nastavenia cookies',
    },
  };
  var locale = (document.documentElement.lang || 'cs')
    .toLowerCase()
    .split('-')[0];
  var text = messages[locale] || messages.cs;
  var policyMeta = document.querySelector('meta[name="mu-cookie-policy-url"]');
  var policyUrl = policyMeta ? policyMeta.getAttribute('content') : '';
  var consentCookie = 'muAnalyticsConsent';
  var consentVersion = 'v1';
  var consentDurationMonths = 6;
  var panel = null;
  var modalBackdrop = null;
  var modalOpener = null;
  var bodyOverflowBeforeModal = null;
  var analyticsLoaded = false;

  function readConsent() {
    var cookies = document.cookie.split(';');
    var i;
    for (i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      var separator = cookie.indexOf('=');
      if (separator >= 0 && cookie.slice(0, separator) === consentCookie) {
        return cookie.slice(separator + 1);
      }
    }
    return '';
  }

  function writeConsent(choice) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      consentCookie +
      '=' +
      consentVersion +
      ':' +
      measurementId +
      ':' +
      choice +
      '; Max-Age=' +
      consentDurationMonths * 30 * 24 * 60 * 60 +
      '; Path=/; SameSite=Lax' +
      secure;
  }

  function hasConsent(choice) {
    return (
      readConsent() === consentVersion + ':' + measurementId + ':' + choice
    );
  }

  function getAnalyticsDefaultChoice() {
    return hasConsent('accepted');
  }

  function clearAnalyticsCookies() {
    var cookies = document.cookie.split(';');
    var hostParts = window.location.hostname.split('.');
    var domains = [''];
    var i;
    var j;

    for (i = 0; i < hostParts.length; i++) {
      domains.push('.' + hostParts.slice(i).join('.'));
    }

    for (i = 0; i < cookies.length; i++) {
      var cookieName = cookies[i].trim().split('=')[0];
      if (!/^_(?:ga(?:_|$)|gid$|gat(?:_|$)|gac_)/i.test(cookieName)) {
        continue;
      }
      for (j = 0; j < domains.length; j++) {
        document.cookie =
          cookieName +
          '=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/' +
          (domains[j] ? '; Domain=' + domains[j] : '') +
          '; SameSite=Lax' +
          (window.location.protocol === 'https:' ? '; Secure' : '');
      }
    }
  }

  function loadAnalytics() {
    if (analyticsLoaded) {
      return;
    }

    analyticsLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    var script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(measurementId);
    script.onerror = function () {
      analyticsLoaded = false;
      console.error('Unable to load Google Analytics.');
    };
    document.head.appendChild(script);
  }

  function removePanel() {
    var focusTarget = modalOpener;
    if (modalBackdrop && modalBackdrop.parentNode) {
      modalBackdrop.parentNode.removeChild(modalBackdrop);
    } else if (panel && panel.parentNode) {
      panel.parentNode.removeChild(panel);
    }
    panel = null;
    modalBackdrop = null;
    modalOpener = null;
    restoreBodyScroll();
    document.removeEventListener('keydown', handleModalKeydown);
    if (focusTarget && document.documentElement.contains(focusTarget)) {
      focusTarget.focus();
    }
  }

  function closeSettings() {
    if (hasConsent('accepted') || hasConsent('rejected')) {
      removePanel();
    } else {
      modalOpener = null;
      renderPanel(false, false);
      var customizeButton = panel.querySelector(
        '.mu-cookie-consent__button:last-child'
      );
      if (customizeButton) {
        customizeButton.focus();
      }
    }
  }

  function handleModalKeydown(event) {
    if (event.key === 'Escape' && modalBackdrop) {
      event.preventDefault();
      closeSettings();
    }
  }

  function restoreBodyScroll() {
    if (bodyOverflowBeforeModal !== null) {
      document.body.style.overflow = bodyOverflowBeforeModal;
      bodyOverflowBeforeModal = null;
    }
  }

  function openSettings(currentChoice) {
    modalOpener = document.activeElement;
    renderPanel(true, currentChoice);
  }

  function mountPanel(showSettings, closeButton) {
    if (showSettings) {
      if (!modalBackdrop) {
        modalBackdrop = document.createElement('div');
        modalBackdrop.className = 'mu-cookie-consent__backdrop';
        modalBackdrop.addEventListener('click', function (event) {
          if (event.target === modalBackdrop) {
            closeSettings();
          }
        });
        bodyOverflowBeforeModal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.body.appendChild(modalBackdrop);
        document.addEventListener('keydown', handleModalKeydown);
      }
      if (panel.parentNode !== modalBackdrop) {
        modalBackdrop.appendChild(panel);
      }
      panel.classList.add('mu-cookie-consent--modal');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (closeButton) {
        closeButton.focus();
      }
      return;
    }

    panel.classList.remove('mu-cookie-consent--modal');
    panel.setAttribute('role', 'region');
    panel.removeAttribute('aria-modal');
    if (modalBackdrop && modalBackdrop.parentNode) {
      var skipLink = document.getElementById('mu-skip-link');
      if (skipLink && skipLink.parentNode) {
        skipLink.parentNode.insertBefore(panel, skipLink.nextSibling);
      } else {
        document.body.insertBefore(panel, document.body.firstChild);
      }
      modalBackdrop.parentNode.removeChild(modalBackdrop);
      modalBackdrop = null;
      restoreBodyScroll();
      document.removeEventListener('keydown', handleModalKeydown);
    } else if (!panel.parentNode) {
      var fallbackSkipLink = document.getElementById('mu-skip-link');
      if (fallbackSkipLink && fallbackSkipLink.parentNode) {
        fallbackSkipLink.parentNode.insertBefore(
          panel,
          fallbackSkipLink.nextSibling
        );
      } else {
        document.body.insertBefore(panel, document.body.firstChild);
      }
    }
  }

  function appendText(parent, tagName, className, value) {
    var element = document.createElement(tagName);
    if (className) {
      element.className = className;
    }
    element.textContent = value;
    parent.appendChild(element);
    return element;
  }

  function createButton(parent, label, handler, iconName) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mu-cookie-consent__button';
    if (iconName) {
      button.className += ' mu-cookie-consent__button--choice';
      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      var circle = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'circle'
      );
      circle.setAttribute('cx', '12');
      circle.setAttribute('cy', '12');
      circle.setAttribute('r', '9');
      icon.appendChild(circle);
      var mark = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      mark.setAttribute(
        'd',
        iconName === 'accept' ? 'm8 12 2.5 2.5L16 9' : 'm8 8 8 8m0-8-8 8'
      );
      icon.appendChild(mark);
      button.appendChild(icon);
    }
    var labelElement = document.createElement('span');
    labelElement.textContent = label;
    button.appendChild(labelElement);
    button.addEventListener('click', handler);
    parent.appendChild(button);
    return button;
  }

  function createDisclosure(parent, label, details) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mu-cookie-settings__disclosure';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', details.id);
    button.setAttribute('aria-label', text.showDetails + ': ' + label);

    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    var chevron = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    chevron.setAttribute('d', 'm6 9 6 6 6-6');
    icon.appendChild(chevron);
    button.appendChild(icon);

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.setAttribute(
        'aria-label',
        (expanded ? text.hideDetails : text.showDetails) + ': ' + label
      );
      details.hidden = !expanded;
    });
    parent.appendChild(button);
    return button;
  }

  function createSwitch(parent, label, checked, disabled) {
    var toggleLabel = document.createElement('label');
    toggleLabel.className = 'mu-cookie-settings__switch';
    if (disabled) {
      toggleLabel.className += ' mu-cookie-settings__switch--disabled';
    }

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.setAttribute('role', 'switch');
    checkbox.setAttribute('aria-label', label);
    checkbox.checked = checked;
    checkbox.disabled = disabled;
    toggleLabel.appendChild(checkbox);

    var track = document.createElement('span');
    track.className = 'mu-cookie-settings__switch-track';
    toggleLabel.appendChild(track);
    parent.appendChild(toggleLabel);
    return checkbox;
  }

  function appendCookieCategory(
    parent,
    id,
    label,
    description,
    headerSwitch,
    tools
  ) {
    var row = document.createElement('section');
    row.className = 'mu-cookie-settings__category';

    var header = document.createElement('div');
    header.className = 'mu-cookie-settings__category-header';
    row.appendChild(header);

    var details = document.createElement('div');
    details.id = id + '-details';
    details.className = 'mu-cookie-settings__details';
    details.hidden = true;
    createDisclosure(header, label, details);

    var headerToggle = null;
    if (headerSwitch) {
      headerToggle = createSwitch(
        header,
        headerSwitch.label,
        headerSwitch.checked,
        headerSwitch.disabled
      );
    }
    appendText(header, 'span', 'mu-cookie-settings__category-label', label);

    appendText(details, 'p', '', description);
    var toolSwitches = [];
    (tools || []).forEach(function (tool) {
      var provider = document.createElement('div');
      provider.className = 'mu-cookie-settings__provider';
      provider.setAttribute('data-cookie-provider', tool.id);
      toolSwitches.push(
        createSwitch(provider, tool.label, tool.checked, false)
      );
      appendText(
        provider,
        'span',
        'mu-cookie-settings__provider-label',
        tool.label
      );
      details.appendChild(provider);
      if (tool.description) {
        appendText(
          details,
          'p',
          'mu-cookie-settings__provider-description',
          tool.description
        );
      }
    });
    row.appendChild(details);
    parent.appendChild(row);
    return {
      headerToggle: headerToggle,
      toolSwitches: toolSwitches,
    };
  }

  function createCloseButton(parent) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mu-cookie-settings__close';
    button.setAttribute('aria-label', text.close);
    button.title = text.close;
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    var cross = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    cross.setAttribute('d', 'm6 6 12 12m0-12L6 18');
    icon.appendChild(cross);
    button.appendChild(icon);
    button.addEventListener('click', closeSettings);
    parent.appendChild(button);
    return button;
  }

  function appendPolicyLink(parent) {
    if (!policyUrl) {
      return;
    }
    var link = document.createElement('a');
    link.className = 'mu-cookie-consent__policy';
    link.href = policyUrl;
    link.textContent = text.policy;
    parent.appendChild(link);
  }

  function saveChoice(accepted) {
    var hadAnalytics = analyticsLoaded;
    writeConsent(accepted ? 'accepted' : 'rejected');
    if (accepted) {
      loadAnalytics();
    } else {
      clearAnalyticsCookies();
    }
    removePanel();
    if (!accepted && hadAnalytics) {
      window.location.reload();
    }
  }

  function renderPanel(showSettings, currentChoice) {
    if (!panel) {
      panel = document.createElement('section');
      panel.className = 'mu-cookie-consent';
    }
    panel.innerHTML = '';

    var header = document.createElement('div');
    header.className = 'mu-cookie-consent__header';
    var title = appendText(
      header,
      'h2',
      'mu-cookie-consent__title',
      text.title
    );
    title.id = 'mu-cookie-consent-title';
    var closeButton = showSettings ? createCloseButton(header) : null;
    panel.appendChild(header);
    panel.setAttribute('aria-labelledby', 'mu-cookie-consent-title');
    var paragraphs;
    if (showSettings) {
      paragraphs = text.settingsDescription;
    } else {
      paragraphs = [
        text.promptDescription.replace(
          '{months}',
          String(consentDurationMonths)
        ),
      ];
    }
    paragraphs.forEach(function (paragraph) {
      appendText(panel, 'p', 'mu-cookie-consent__description', paragraph);
    });
    appendPolicyLink(panel);

    if (showSettings) {
      appendText(
        panel,
        'h3',
        'mu-cookie-settings__heading',
        text.consentHeading
      );

      appendCookieCategory(
        panel,
        'mu-cookie-necessary',
        text.necessary,
        text.necessaryDescription,
        { label: text.necessary, checked: true, disabled: true },
        []
      );
      var analyticsTools = [
        {
          id: 'google-analytics',
          label: text.googleAnalytics,
          checked: !!currentChoice,
          description: text.googleAnalyticsDescription.replace(
            '{months}',
            String(consentDurationMonths)
          ),
        },
      ];
      var analyticsSettings = appendCookieCategory(
        panel,
        'mu-cookie-analytics',
        text.analytics,
        text.analyticsDescription.replace(
          '{months}',
          String(consentDurationMonths)
        ),
        {
          label: text.analyticsAll,
          checked: !!currentChoice,
          disabled: false,
        },
        analyticsTools
      );
      var analyticsToggle = analyticsSettings.headerToggle;
      var analyticsToggles = analyticsSettings.toolSwitches;

      analyticsToggle.addEventListener('change', function () {
        analyticsToggles.forEach(function (toggle) {
          toggle.checked = analyticsToggle.checked;
        });
      });
      var syncAnalyticsMaster = function () {
        var selectedCount = analyticsToggles.filter(function (toggle) {
          return toggle.checked;
        }).length;
        analyticsToggle.checked = selectedCount === analyticsToggles.length;
      };
      analyticsToggles.forEach(function (toggle) {
        toggle.addEventListener('change', syncAnalyticsMaster);
      });
      syncAnalyticsMaster();

      var settingsActions = document.createElement('div');
      settingsActions.className = 'mu-cookie-settings__actions';
      var removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'mu-cookie-settings__action';
      removeButton.textContent = text.remove;
      removeButton.addEventListener('click', function () {
        saveChoice(false);
      });
      settingsActions.appendChild(removeButton);
      createButton(settingsActions, text.confirm, function () {
        saveChoice(analyticsToggles[0].checked);
      });
      panel.appendChild(settingsActions);
    } else {
      panel.setAttribute('role', 'region');
      panel.removeAttribute('aria-modal');
      var actions = document.createElement('div');
      actions.className = 'mu-cookie-consent__actions';
      panel.appendChild(actions);
      createButton(
        actions,
        text.accept,
        function () {
          saveChoice(true);
        },
        'accept'
      );
      createButton(
        actions,
        text.reject,
        function () {
          saveChoice(false);
        },
        'reject'
      );
      createButton(actions, text.customize, function () {
        openSettings(getAnalyticsDefaultChoice());
      });
    }

    mountPanel(showSettings, closeButton);
  }

  function addFooterSettingsLink() {
    var footer = document.querySelector('.footer__info p');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'mu-cookie-consent__footer-fallback';
      document.body.appendChild(footer);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mu-cookie-consent__footer-link';
    button.textContent = text.footer;
    button.addEventListener('click', function () {
      openSettings(getAnalyticsDefaultChoice());
    });
    footer.appendChild(button);
  }

  addFooterSettingsLink();
  if (hasConsent('accepted')) {
    loadAnalytics();
  } else if (!hasConsent('rejected')) {
    renderPanel(false, false);
  }
})();

jQuery(document).ready(function ($) {
  var logo = document.getElementById('mu-portal-logo');
  var portalName = document.getElementById('mu-portal-name');
  if (logo && portalName) {
    var hideBrokenLogo = function () {
      logo.removeEventListener('error', hideBrokenLogo);
      logo.style.display = 'none';
    };

    logo.addEventListener('error', hideBrokenLogo);
    if (logo.complete && logo.naturalWidth === 0) {
      hideBrokenLogo();
    }
  }

  // vlastní select Select2 ( https://select2.org/ )
  if ($('.mu-js-select').length) {
    $('.mu-js-select').select2({
      language: 'cs',
    });
  }

  // select - vybraná položka
  if ($('.mu-js-select-selected').length) {
    $('.mu-js-select-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      width: 'resolve',
    });
  }

  // select - položka s vyhledáváním
  if ($('.mu-js-select-search').length) {
    $('.mu-js-select-search').select2({
      language: 'cs',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - vybraná položka s vyhledáváním
  if ($('.mu-js-select-search-selected').length) {
    $('.mu-js-select-search-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - řešení multiple selectu
  if ($('.mu-js-select-multi').length) {
    $('.mu-js-select-multi').on('change', function () {
      var selectActual = $(this).val();
      var selectConnect = '#' + $(this).data('multi');
      // skrytý multiselect obsahuje jen vybrané hodnoty, novou volbu do něj přidáme
      var $connect = $(selectConnect);
      var $option = $connect.find('option').filter(function () {
        return this.value === selectActual;
      });
      if (!$option.length && selectActual) {
        $option = $('<option>').val(selectActual).text(selectActual);
        $connect.append($option);
      }
      $option.prop('selected', true);
      // nastavení stránkování na 1
      $('#strana').val(1);
      // odeslání formuláře
      $('#sbirky').submit();
    });
  }

  // select - datum se sliderem
  if ($('.mu-js-date-slider').length) {
    $('.mu-js-date-slider .mu-select-false__input').on('click', function () {
      $(this).next('.mu-slider').toggleClass('is-open');
    });
  }

  // select - odeslání formuláře sbírky po změně
  $('.mu-js-submit-collection').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // select - odeslání formuláře kolekce po změně
  $('.mu-js-submit-collist').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#collist').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-select').on('change', function () {
    if ($(this).data('input') === 'pl') {
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('pl', $(this).val());
      pageUrl.searchParams.set('strana', '1');
      pageUrl.searchParams.delete('more');
      window.location.href = pageUrl.toString();
      return;
    }

    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-input').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - stránkování
  $('.mu-js-form-page').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-checkbox').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = '0';

    if ($(this).prop('checked')) {
      inputValue = '1';
    }

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // přepínač "Pouze s obrázkem" v demo-test: zachová ostatní filtry v URL
  $('.mu-js-toggle-jo').on('change', function () {
    var nextUrl = new URL(window.location.href);

    if ($(this).prop('checked')) {
      nextUrl.searchParams.set('jo', '1');
    } else {
      nextUrl.searchParams.set('jo', '0');
    }

    nextUrl.searchParams.set('strana', '1');
    nextUrl.searchParams.delete('more');
    nextUrl.searchParams.delete('do');
    nextUrl.searchParams.delete('check');

    var nextPathAndSearch = nextUrl.pathname + nextUrl.search;
    var currentPathAndSearch =
      window.location.pathname + window.location.search;

    if (nextPathAndSearch !== currentPathAndSearch) {
      window.location.href = nextPathAndSearch;
    }
  });

  function muScrollOffset() {
    var header = document.querySelector('.header.mu-sticky-header--fixed');
    return (header ? header.offsetHeight : 0) + 12;
  }

  jQuery(document).ready(function ($) {
    function updatePaginationLinks(currentPage) {
      $('.mu-meta__paging').each(function () {
        var $paging = $(this);
        var $prev = $paging.find('.mu-meta__prev');
        var $next = $paging.find('.mu-meta__next');

        if ($prev.length > 0) {
          var prevHref = $prev.attr('href');
          if (prevHref) {
            var prevUrl = new URL(prevHref, window.location.origin);
            prevUrl.searchParams.set(
              'strana',
              String(Math.max(currentPage - 1, 1))
            );
            prevUrl.searchParams.set('more', '0');
            $prev.attr(
              'href',
              prevUrl.pathname + prevUrl.search + prevUrl.hash
            );
          }
        }

        if ($next.length > 0) {
          var nextHref = $next.attr('href');
          if (nextHref) {
            var nextUrl = new URL(nextHref, window.location.origin);
            nextUrl.searchParams.set('strana', String(currentPage + 1));
            nextUrl.searchParams.set('more', '0');
            $next.attr(
              'href',
              nextUrl.pathname + nextUrl.search + nextUrl.hash
            );
          }
        }
      });
    }

    $('.mu-js-load-more').on('click', function (e) {
      var $btn = $(this);
      var $list = $('#mu-items-list');
      if ($list.length === 0) {
        return;
      }

      e.preventDefault();

      var href = $btn.attr('href').split('#')[0];
      var sep = href.indexOf('?') === -1 ? '?' : '&';
      var offset = parseInt($btn.data('offset'), 10) || 0;
      var step = parseInt($btn.data('step'), 10) || 12;
      var previousItemCount = $list.children().length;
      var currentPage = parseInt($('#strana').val(), 10) || 1;

      $btn.prop('disabled', true).addClass('is-loading');

      $.get(href + sep + 'ajaxMore=1&offset=' + offset)
        .done(function (html, status, xhr) {
          $list.append(html);

          var $newItems = $list.children().slice(previousItemCount);
          if ($newItems.length > 0) {
            currentPage += 1;
            $('#strana').val(currentPage);
            $('.mu-js-form-page').val(currentPage);
            updatePaginationLinks(currentPage);

            var targetScrollTop = Math.max(
              $newItems.first().offset().top - muScrollOffset(),
              0
            );
            $('html, body')
              .stop(true)
              .animate({ scrollTop: targetScrollTop }, 300);
          }

          var nextOffset = offset + step;
          $btn.data('offset', nextOffset);
          $btn.attr(
            'href',
            href.replace(/([?&]more=)\d+/, '$1' + (nextOffset + step))
          );

          if (xhr.getResponseHeader('X-Has-More') === '1') {
            $btn.prop('disabled', false).removeClass('is-loading');
          } else {
            $btn.closest('.mu-meta__button').remove();
          }
        })
        .fail(function () {
          $btn.prop('disabled', false).removeClass('is-loading');
        });
    });
  });

  jQuery(document).ready(function ($) {
    var section = '#mu-collection-items';

    function withParams(href, extra) {
      var url = new URL(href.split('#')[0], window.location.origin);
      Object.keys(extra).forEach(function (key) {
        url.searchParams.set(key, extra[key]);
      });
      return url.pathname + url.search;
    }

    function scrollTo($element) {
      var target = Math.max($element.offset().top - muScrollOffset(), 0);
      $('html, body').stop(true).animate({ scrollTop: target }, 300);
    }

    $(document).on(
      'click',
      section + ' .mu-meta__prev, ' + section + ' .mu-meta__next',
      function (e) {
        var $section = $(section);
        var href = $(this).attr('href');
        if (!href) {
          return;
        }

        e.preventDefault();
        $section.addClass('is-loading');

        $.get(withParams(href, { ajaxColPage: 1 }))
          .done(function (html) {
            $section.html(html);
            if (window.history && window.history.pushState) {
              window.history.pushState({}, '', href.split('#')[0]);
            }
            scrollTo($section);
          })
          .fail(function () {
            window.location.href = href;
          })
          .always(function () {
            $section.removeClass('is-loading');
          });
      }
    );

    $(document).on('click', section + ' .mu-js-col-load-more', function (e) {
      var $btn = $(this);
      var $list = $(section).find('#mu-items-list');
      if ($list.length === 0) {
        return;
      }

      e.preventDefault();

      var href = $btn.attr('href');
      var offset = parseInt($btn.data('offset'), 10) || 0;
      var step = parseInt($btn.data('step'), 10) || 12;
      var previousItemCount = $list.children().length;

      $btn.addClass('is-loading');

      $.get(withParams(href, { ajaxMore: 1, offset: offset }))
        .done(function (html, status, xhr) {
          $list.append(html);

          var $newItems = $list.children().slice(previousItemCount);
          if ($newItems.length > 0) {
            scrollTo($newItems.first());
          }

          var nextOffset = offset + step;
          $btn.data('offset', nextOffset);
          $btn.attr('href', withParams(href, { more: nextOffset + step }));

          if (xhr.getResponseHeader('X-Has-More') === '1') {
            $btn.removeClass('is-loading');
          } else {
            $btn.closest('.mu-meta__button').remove();
          }
        })
        .fail(function () {
          $btn.removeClass('is-loading');
        });
    });
  });

  // vlastní slider
  if ($('#mu-slider').length) {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    var slider = document.getElementById('mu-slider');

    noUiSlider.create(slider, {
      start: [sliderMinSelected, sliderMaxSelected],
      connect: true,
      step: 1,
      range: {
        min: sliderMin,
        max: sliderMax,
      },
    });

    var dateValues = [
      document.getElementById('mu-slider-min'),
      document.getElementById('mu-slider-max'),
    ];

    // aktualizace hodnot v inputech
    slider.noUiSlider.on('update', function (values, handle) {
      dateValues[handle].value = Math.ceil(values[handle]);
    });

    // odeslání formuláře po tažení
    slider.noUiSlider.on('set', function (values, handle) {
      sliderChecker();
    });
  }

  // odeslání formuláře po ruční změně
  $('#mu-slider-min').on('change', function () {
    sliderChecker();
  });
  $('#mu-slider-max').on('change', function () {
    sliderChecker();
  });

  // řešení odeslání formuláře po změně hodnot slideru
  function sliderChecker() {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    // nastavení stránkování na 1
    $('#strana').val(1);

    // hodnoty do skrytých polí (pro porovnání)
    var sliderMinActual = dateValues[0].value;
    var sliderMaxActual = dateValues[1].value;
    if (sliderMinSelected != sliderMinActual) {
      $('#datfset').val(sliderMinActual);
    }
    if (sliderMaxSelected != sliderMaxActual) {
      $('#dattset').val(sliderMaxActual);
    }

    // odeslání formuláře
    $('#sbirky').submit();
  }
});


//# sourceMappingURL=scripts.js.map
